__turbopack_context__.v({
  "breadcrumbs": "cRwVdW_breadcrumbs",
  "feedback": "cRwVdW_feedback",
  "headerActions": "cRwVdW_headerActions",
  "notification": "cRwVdW_notification",
  "search": "cRwVdW_search",
});
